import { styled } from 'baseui'
import { FlexCenter } from '@/shared/theme/styled-components'

export const LoaderCard = styled(FlexCenter, ({ $theme }) => ({
  width: '100%',
  padding: '2.5rem 2rem',
  backgroundColor: $theme.colors.white,
  borderRadius: '1rem',
  minHeight: '6.25rem',
}))

export const LoaderContent = styled(FlexCenter, {
  width: '100%',
})

export const LoaderText = styled('span', ({ $theme }) => ({
  marginLeft: '1.1rem',
  fontSize: '1.1rem',
  color: $theme.colors.textLoading,
  fontWeight: 400,
  lineHeight: 1,
}))
